import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Trans } from 'react-i18next'
import * as S from './LogosCarousel.styles'

const logos = Array.from(
  { length: 18 },
  (_, i) =>
    `${process.env.CDN_URL}/public/landingpagev2/images/banner-home/item-${i + 1}.png`
)

const settings = {
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  slidesToShow: 5.2,
  slidesToScroll: 1,
  infinite: true,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4.2
      }
    }
  ]
}

const LogosCarousel = () => {
  return (
    <>
      <S.CarouselSection>
        <S.Title>
          <Trans
            i18nKey="landingV2.logosCarousel.title"
            components={{ span: <span className="number" /> }}
          />
        </S.Title>
        <S.LogoSlider>
          <Slider {...settings}>
            {logos.map((src, idx) => (
              <div key={idx}>
                <img src={src} alt={`Logo ${idx + 1}`} />
              </div>
            ))}
          </Slider>
        </S.LogoSlider>
      </S.CarouselSection>
    </>
  )
}

export default LogosCarousel
